import React from 'react';
import ReactDOM from 'react-dom/client';

// Bootstrap first, then our SCSS layer so its overrides win.
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/main.scss';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
